"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MotionPanelControl = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const bridge_1 = require("@completeanatomy/bridge");
const i18n_1 = require("@completeanatomy/i18n");
const ui_1 = require("@completeanatomy/ui");
const useMotionPanelControlState_1 = require("../../hooks/useMotionPanelControlState");
const styled_components_1 = __importStar(require("styled-components"));
const MotionPanelControl = () => {
    const { t } = (0, i18n_1.useTranslation)();
    const state = (0, useMotionPanelControlState_1.useMotionPanelControlState)();
    const bridge = (0, bridge_1.useBridge)();
    const onTogglePlayPause = () => {
        (state === null || state === void 0 ? void 0 : state.isPaused)
            ? bridge === null || bridge === void 0 ? void 0 : bridge.motionAnimationPlayAction()
            : bridge === null || bridge === void 0 ? void 0 : bridge.motionAnimationPauseAction();
    };
    const onSliderValueChange = (value) => {
        if (typeof value !== 'number') {
            return;
        }
        bridge === null || bridge === void 0 ? void 0 : bridge.motionAnimationMovementValueChangeAction({ value });
    };
    if (!state) {
        return null;
    }
    const { articulationLabel, rangeOfMotionLabel, isMovementVisible, movementLabel, movementValue, isPaused, sliderValue, } = state;
    return ((0, jsx_runtime_1.jsxs)(Container, { "data-e2e": 'Container', children: [(0, jsx_runtime_1.jsxs)(Top, { "$visible": isMovementVisible, "data-e2e": 'Top', children: [t(i18n_1.Strings.infoBox.motions[movementLabel]), ": ", (0, jsx_runtime_1.jsx)(Degree, { "data-e2e": 'Degree', children: movementValue })] }), (0, jsx_runtime_1.jsxs)(SliderContainer, { "data-e2e": 'SliderContainer', children: [(0, jsx_runtime_1.jsx)(StyledPlayPauseButton, { onClick: onTogglePlayPause, tabIndex: 2, "data-e2e": 'StyledPlayPauseButton', children: (0, jsx_runtime_1.jsx)(ui_1.Icon, { name: isPaused ? ui_1.Icons.Play : ui_1.Icons.Pause, width: 20, height: 20, "data-e2e": 'Icon' }) }), (0, jsx_runtime_1.jsx)(StyledSlider, { currentValue: sliderValue, onChange: onSliderValueChange, "data-e2e": 'StyledSlider' })] }), (0, jsx_runtime_1.jsxs)(Bottom, { "data-e2e": 'Bottom', children: [(0, jsx_runtime_1.jsxs)("div", { "data-e2e": 'div', children: [t(i18n_1.Strings.infoBox.motion.articulation) + ' ', articulationLabel] }), (0, jsx_runtime_1.jsxs)(Range, { "data-e2e": 'Range', children: [(0, jsx_runtime_1.jsx)("div", { "data-e2e": 'div', children: t(i18n_1.Strings.infoBox.motion.rangeOfMotion) }), (0, jsx_runtime_1.jsx)("div", { "data-e2e": 'div', children: rangeOfMotionLabel })] })] })] }));
};
exports.MotionPanelControl = MotionPanelControl;
const Container = styled_components_1.default.div `
  font-size: 16px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  width: fit-content;
  background-color: transparent;
  border-radius: 8px;
  color: ${({ theme }) => theme.grasshopper.text.white};

  ${ui_1.deviceMainScreen.mobile((0, styled_components_1.css) `
    width: 100%;
  `)};
`;
const Top = styled_components_1.default.div `
  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
  transition: opacity 0.3s ease-in-out;
`;
const Bottom = styled_components_1.default.div `
  display: flex;
  gap: 24px;

  ${ui_1.deviceMainScreen.mobile((0, styled_components_1.css) `
    flex-direction: column;
    gap: 8px;
  `)};
`;
const Range = styled_components_1.default.div `
  display: flex;
  gap: 4px;

  ${ui_1.deviceMainScreen.mobile((0, styled_components_1.css) `
    flex-direction: column;
    gap: 0;
  `)};
`;
const SliderContainer = styled_components_1.default.div `
  display: flex;
  align-items: center;
  gap: 16px;
  width: 100%;
  max-width: 400px;
`;
const StyledSlider = (0, styled_components_1.default)(ui_1.Slider) `
  .track {
    height: 4px;
  }

  .track-0 {
    background-color: ${props => props.theme.grasshopper.focusBorder};
  }

  .thumb {
    width: 19px;
    height: 19px;
    color: #ff5722;
    border-radius: 50%;
    cursor: pointer;
  }
`;
const StyledPlayPauseButton = styled_components_1.default.button `
  padding: 10px;
  border: none;
  border-radius: 4px;
  background: transparent;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${({ theme }) => theme.grasshopper.text.white};

  &:hover {
    background-color: ${({ theme }) => theme.grasshopper.menuButtons.hoverBackground};
  }

  &:focus-visible {
    outline: none;
    border: 2px solid ${({ theme }) => theme.designSystem.accent};
  }
`;
const Degree = styled_components_1.default.span `
  &::after {
    content: '\\00BA';
  }
`;
